import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

import { initializeEcho } from './initialize-echo';

const runtime = Object.fromEntries(
    Object.entries({
        appKey: 'reverb-app-key',
        host: 'reverb-host',
        port: 'reverb-port',
        scheme: 'reverb-scheme',
    }).map(([key, name]) => [
        key,
        document
            .querySelector(`meta[name="${name}"]`)
            ?.getAttribute('content') ?? '',
    ]),
);

initializeEcho({
    Echo,
    Pusher,
    environment: import.meta.env,
    runtime,
    target: window,
});
